import { defineMessages } from 'react-intl';

export default defineMessages({
    Copyright: {
        id: 'ml.quoteandbind.common.footer.pe.copyright',
        defaultMessage: '© 2024 Foremost Insurance'
    }
});
